// extracted by mini-css-extract-plugin
export default {"features":"howItWorks_features__8B6CB","featuresContent":"howItWorks_featuresContent__qVBuN","imgContainerFeatures":"howItWorks_imgContainerFeatures__pHrce"};